// Funções reutilizáveis para validação de campos de formulário
// Todas retornam boolean (true = válido, false = inválido)
// Usadas principalmente no validationRules do RegisterForm

/**
 * Valida se um CPF tem 11 dígitos.
 * NOTA: valida APENAS a quantidade de dígitos, não calcula os dígitos verificadores.
 */
export const validateCPF = (cpf) => {
  const numbers = cpf.replace(/\D/g, '');
  return numbers.length === 11;
};

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validateCEP = (cep) => {
  return cep.replace(/\D/g, '').length === 8;
};

/**
 * Telefone é válido com 10 dígitos (fixo com DDD) ou 11 dígitos (celular com DDD).
 */
export const validatePhone = (phone) => {
  const numbers = phone.replace(/\D/g, '');
  return numbers.length >= 10 && numbers.length <= 11;
};

/**
 * Considera strings com apenas espaços como vazias.
 */
export const validateRequired = (value) => {
  if (!value) return false;
  return value.toString().trim() !== '';
};

const validateCNPJ = (cnpj) => {
  const numbers = cnpj.replace(/\D/g, '');

  if (numbers.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(numbers)) return false;

  let soma = 0;
  let peso = 5;
  for (let i = 0; i < 12; i++) {
    soma += parseInt(numbers[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }

  let resto = soma % 11;
  let digito1 = resto < 2 ? 0 : 11 - resto;
  if (digito1 !== parseInt(numbers[12])) return false;

  soma = 0;
  peso = 6;
  for (let i = 0; i < 13; i++) {
    soma += parseInt(numbers[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }

  resto = soma % 11;
  let digito2 = resto < 2 ? 0 : 11 - resto;

  return digito2 === parseInt(numbers[13]);
};

export const validateDocument = (documento) => {
  const numbers = documento.replace(/\D/g, '');
  if (numbers.length === 11) return validateCPF(numbers);
  if (numbers.length === 14) return validateCNPJ(numbers);
  return false;
};